import { render } from "./PcHeadShopHome.vue?vue&type=template&id=1b4309c9&scoped=true"
import script from "./PcHeadShopHome.vue?vue&type=script&lang=js"
export * from "./PcHeadShopHome.vue?vue&type=script&lang=js"

import "./PcHeadShopHome.vue?vue&type=style&index=0&id=1b4309c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4309c9"]])

export default __exports__